//import "./style.scss";
import { auth, createElement } from "../global";
import { confirmPasswordReset } from "firebase/auth";
import { FirebaseError } from "firebase/app";

/* START HTML */
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const headerDiv = document.querySelector<HTMLElement>(".container.clr.page-header-inner")!;
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const appDiv = document.querySelector<HTMLDivElement>(".entry")!;
const resetForm = createElement("form", { parent: appDiv });

createElement("h2", { parent: resetForm, text: "Neues Passwort eingeben:" });

createElement("label", {
  parent: resetForm,
  for: "password1Input",
  text: "Passwort:",
  hidden: true,
});
const password1Input = createElement("input", {
  parent: resetForm,
  type: "password",
  id: "password1Input",
  name: "password1",
});
password1Input.required = true;
password1Input.pattern = "^\\S{6,}$";
password1Input.onchange = function () {
  const input = <HTMLInputElement>this;
  input.setCustomValidity(
    input.validity.patternMismatch ? "Passwort muss mindestens 6 Zeichen lang sein" : ""
  );
  if (input.checkValidity()) password2Input.pattern = input.value;
};
createElement("label", { parent: resetForm, for: "password2Input", text: "Passwort bestätigen:" });
const password2Input = createElement("input", {
  parent: resetForm,
  type: "password",
  id: "password2Input",
  name: "password2",
});
password2Input.required = true;
password2Input.onchange = function () {
  const input = <HTMLInputElement>this;
  input.setCustomValidity(input.validity.patternMismatch ? "Passwörter stimmen nicht überein" : "");
};

createElement("input", { parent: resetForm, id: "submit", type: "submit", value: "Registrieren" });
/* END HTML */

//check auth
auth.onAuthStateChanged(function (user) {
  if (user) {
    // User is signed in.
    window.location.href = "/intern";
  } else {
    // No user is signed in.
  }
});

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

const mode = urlParams.get("mode");
const actionCode = urlParams.get("oobCode");

if (mode === "resetPassword") {
  // Display reset password handler and UI.
  handleResetPassword();
}

function handleResetPassword() {
  resetForm.hidden = false;
  headerDiv.children[0].innerHTML = "Password Zurücksetzen";
  document.title = "Password Zurücksetzen";
}

resetForm.onsubmit = (event) => {
  event.preventDefault();
  const data = new FormData(resetForm);
  if (!data.has("password1")) return;
  const password = data.get("password1")?.toString();
  if (password && actionCode)
    confirmPasswordReset(auth, actionCode, password)
      .then(() => {
        alert("Passwort zurückgesetzt");
        window.location.href = "/login";
      })
      .catch((e: FirebaseError) => {
        console.log(e);
        alert(e.message);
      });
};
